export default "__VITE_ASSET__Dv7e8N_k__"